// POST /offeringFulfillmentRequest rejections carry ServiceNow's reason in a
// ticket envelope, e.g. HTTP 400 with
//   { "message": { "TicketResponseMessage": "Catalog Item: 'Galileo Platform' does not exist.",
//                  "TicketResponseCode": "603", ... } }
// HttpErrorResponse puts that body under `.error`, as an object or (with a
// text response type) a JSON string. Returns the reason, or null if absent.
export function extractTicketResponseMessage(err: unknown): string | null {
  let body: unknown = (err as { error?: unknown } | null)?.error;
  if (typeof body === 'string') {
    try {
      body = JSON.parse(body);
    } catch {
      return null;
    }
  }
  const envelope = (body as { message?: unknown } | null)?.message;
  const reason = (envelope as { TicketResponseMessage?: unknown } | null)?.TicketResponseMessage;
  return typeof reason === 'string' && reason.trim() ? reason.trim() : null;
}
